export function installReducer(state = { 
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_INSTALL": 
        case "UPDATE_INSTALL": 
            return {
                [payload.id]: payload,
                ...state
            };
        case "RECEIVED_INSTALL":        
            return {
                ...state,
                [payload]: {
                    ...state[payload],
                    received: true
                }
            }
        case "GET_INSTALLS":        
            return payload;
        
        case "DELETE_INSTALL":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}